'use client';

import { createContext, useContext, useState } from 'react';
const EnvContext = createContext<any>(undefined);
export function EnvWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  const [userUrl, setUserUrl] = useState('');
  const [chApi, setChApi] = useState('');
  const [webUrl, setWebUrl] = useState('');
  const [cdnEnv, setCdnEnv] = useState<any>('');
  return <EnvContext.Provider value={{
    userUrl,
    setUserUrl,
    chApi,
    setChApi,
    webUrl,
    setWebUrl,
    cdnEnv,
    setCdnEnv
  }} data-sentry-element="unknown" data-sentry-component="EnvWrapper" data-sentry-source-file="envContext.tsx">
   {children}
  </EnvContext.Provider>;
}
export function useEnvContext() {
  return useContext(EnvContext);
}